<template>
  <div v-if="props.object" class="product-content flex-column">
    <div class="product-detail">
      <ImageGallery
        :images="props.object.images"
        :download="object.name"
        :alt="object.name"
      />
      <div class="content">
        <RouterLink
          :to="{
            name: 'product-detail',
            params: { slug: object.slug },
            query: { back: props.back },
          }"
          class="product-name"
        >
          <h2>{{ props.object.name }}</h2>
        </RouterLink>
        <ProductPrice :object="props.object" class="price" />

        <div class="categories">
          <div v-for="category of categoryLabels" class="category-space">
            {{ category }}
          </div>
        </div>

        <div class="add-row flex-row flex-align-center">
          <AddToCart expanded :object="props.object" />
        </div>
        <RelatedProductsList
          :object="props.object"
          :count="4"
          :setsOnly="true"
        />
        <div class="remote-id">{{ props.object.remote_id }}</div>
      </div>
    </div>
    <div class="footer" />
  </div>
  <div v-else-if="!shop.isReady"></div>
  <div v-else>
    <h2>Product Not Found</h2>
    {{ props.object }}
  </div>
</template>

<route lang="json">
{
  "name": "product-detail",
  "meta": { "fullWidth": true }
}
</route>

<script setup lang="ts">
import ImageGallery from "@/components/shop/ImageGallery.vue";
import RelatedProductsList from "@/components/shop/RelatedProductsList.vue";
import type { Product } from "@/stores/defs/shop_defs";
import { useShopStore } from "@/stores/shop";
import { getCategoryLabels } from "@/utils/shop";
import { computed } from "vue";
import AddToCart from "./AddToCart.vue";
import ProductPrice from "./ProductPrice.vue";

const props = defineProps<{
  object: Product;
  back?: string;
}>();
const shop = useShopStore();

const categoryLabels = computed(() => {
  return getCategoryLabels(props.object);
});
</script>

<style scoped>
:deep(.related-products) {
  background: white;
  padding: 0 0 var(--md, 32px) 0;
}
:deep(.related-products h4) {
  text-align: left;
  text-transform: capitalize;
  margin-bottom: var(--2XS, 8px);
}

:deep(.product-list) {
  gap: var(--XS, 16px);
  justify-content: left;
}

.product-detail {
  max-width: 845px;
  display: flex;
  flex-direction: row;
  /*padding: 0 var(--Sm);*/
  /* margin: auto; */
  gap: var(--sm, 24px);
  :deep(.mini) {
    width: 72px;
  }
  :deep(.mini img) {
    height: 90px;
    width: 72px;
  }
  :deep(.related-products .flex-row) {
    gap: var(--XS, 8px);
  }
  :deep(.mini-name) {
    display: none;
  }
  .related-products :deep(.flex-row .mini:nth-child(1)) {
    margin-left: -24px;
  }
}
.product-detail > * {
  flex: 1 1 1px;
}
.product-name:hover h2 {
  text-shadow: 0 0 1px black;
}

h2 {
  color: var(--Black, #000);

  /* Name of Piece */
  font-family: Indivisible;
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-align: left;
  text-transform: none;
}
.small {
  gap: 24px;
}
.small > img {
  max-width: 72px;
}
img.main {
  width: 100%;
  height: 432px;
  aspect-ratio: 345 / 432;
  object-fit: cover;
}
.add-row {
  display: flex;
  flex-direction: row;
  gap: var(--XS, 16px);
  margin: var(--md) 0;
}
.price {
  color: var(--Black, #000);

  /* Subhead 1 */
  font-family: Indivisible;
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  padding-top: var(--2XS, 8px);
}
.remote-id {
  color: var(--Black, #000);

  /* Small Print */
  font-family: Indivisible;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.product-detail :deep(.content) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .categories {
    margin: var(--md, 32px) 0 0 0;
    font-size: 14px;
    font-weight: 400;
    padding: var(--2XS, 8px) 0;
    .category-space {
      padding: 0 var(--XS, 16px);
      float: left;
      border-right: 1px solid var(--50, #939598);
    }
    .category-space:first-child {
      padding-left: 0;
    }
    .category-space:last-child {
      padding-right: 0;
      border-right: none;
    }
  }
}
</style>
